/**
 * Ambassadors program – category tab filtering and profile modal.
 */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.ambInitialized === 'true') return;
    root.dataset.ambInitialized = 'true';

    initFilters(root);
    initModal(root);
  }

  function initFilters(root) {
    var filterButtons = root.querySelectorAll('[data-amb-filter]');
    var cardWraps = root.querySelectorAll('[data-amb-card-wrap]');

    if (!filterButtons.length || !cardWraps.length) return;

    function applyFilter(filter) {
      cardWraps.forEach(function (wrap) {
        var card = wrap.querySelector('[data-amb-card]');
        if (!card) return;

        var category = card.dataset.ambCategory || '';
        var show =
          filter === 'all' || category === '' || category === filter;

        wrap.classList.toggle('is-hidden', !show);
      });

      filterButtons.forEach(function (btn) {
        var isActive = btn.dataset.ambFilter === filter;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.dataset.ambFilter || 'all');
      });
    });
  }

  function initModal(root) {
    var modal = root.querySelector('[data-amb-modal]');
    if (!modal) return;

    var panels = modal.querySelectorAll('[data-amb-modal-panel]');
    var triggers = root.querySelectorAll('[data-amb-modal-open]');
    var closeElements = modal.querySelectorAll('[data-amb-modal-close]');
    var activePanel = null;
    var lastTrigger = null;

    function showPanel(panelId) {
      panels.forEach(function (panel) {
        var isActive = panel.dataset.ambModalPanelId === panelId;
        panel.hidden = !isActive;
        if (isActive) activePanel = panel;
      });
    }

    function openModal(panelId, trigger) {
      showPanel(panelId);
      lastTrigger = trigger || null;
      modal.removeAttribute('inert');
      modal.setAttribute('aria-hidden', 'false');

      if (typeof modal.showModal === 'function') {
        if (!modal.open) modal.showModal();
      } else {
        modal.setAttribute('open', 'open');
      }

      var closeBtn = modal.querySelector('.ambassadors-program__modal-close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      if (typeof modal.close === 'function' && modal.open) {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }

      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('inert', '');

      panels.forEach(function (panel) {
        panel.hidden = true;
      });

      activePanel = null;

      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panelId = trigger.dataset.ambModalOpen;
        if (!panelId) return;
        openModal(panelId, trigger);
      });
    });

    closeElements.forEach(function (el) {
      el.addEventListener('click', function () {
        closeModal();
      });
    });

    modal.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeModal();
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
  }

  function boot() {
    document
      .querySelectorAll('[data-ambassadors-program]')
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ambassadors-program]');
    if (root) {
      root.dataset.ambInitialized = 'false';
      initSection(root);
    }
  });
})();
